var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.syncMultiShow,
          expression: "syncMultiShow"
        }
      ],
      staticClass: "popup",
      attrs: { id: "syncMulti" }
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "transferAim" } }, [
        _c("div", { staticClass: "title" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("language.popup.cloudTransferPopup.pleaSelect"))
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.closeTreeDialog()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            ref: "aimTree",
            staticClass: "task-content",
            attrs: { id: "taskContent" }
          },
          [
            _c(
              "el-scrollbar",
              { ref: "elscrollbar", staticStyle: { height: "100%" } },
              [
                !_vm.model.length && !_vm.loading
                  ? _c(
                      "div",
                      {
                        staticClass: "real-nodrives",
                        on: {
                          click: function($event) {
                            return _vm.toAddCloudPage()
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "nondrive-realtime" }),
                        _vm._v(" "),
                        _vm.realTimeMode
                          ? _c("div", { staticClass: "nondrive-realtimedes" }, [
                              _vm._v(
                                "\r\n                    " +
                                  _vm._s(
                                    _vm.$t("language.cloudSync.addRealDrives")
                                  ) +
                                  "\r\n               "
                              )
                            ])
                          : _c("div", { staticClass: "nondrive-realtimedes" }, [
                              _vm._v(
                                "\r\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "language.popup.cloudTransferPopup.addValidCloud"
                                    )
                                  ) +
                                  "\r\n               "
                              )
                            ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { id: "treeNodes" } },
                  _vm._l(_vm.model, function(item, index) {
                    return _c(
                      "ul",
                      { key: index },
                      [
                        _c("tree", {
                          ref: "tree",
                          refInFor: true,
                          attrs: {
                            model: item,
                            index: index,
                            treeShow: true,
                            transferAimFlag: _vm.transferAimFlag
                          }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "task-footer" }, [
          !_vm.toWayShow && !_vm.realTimeMode
            ? _c("div", [
                _c("div", {
                  staticClass: "icon-util nocheck move-position",
                  class: [
                    _vm.$store.state.syncMultiSelect == true ? "check" : ""
                  ],
                  on: {
                    click: function($event) {
                      return _vm.multi($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "multi-select" }, [
                  _vm._v(_vm._s(_vm.$t("language.common.multiSelect")))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "task-button",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.syncAimSubmit()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd0b37da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd0b37da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_transfer_popups/sync_multi_popup.vue
// module id = null
// module chunks = 